export const PER_PAGE_OPTIONS = [25, 50, 100, 250]

export const DEFAULT_STATE = {
  q: '',
  type: 'all',
  state: 'all',
  iso: 'all',
  curated: false,
  sort: 'customers',
  direction: 'desc',
  page: 1,
  perPage: 50
}

// Default sort direction per sort mode (used when switching sort modes).
export const DEFAULT_DIRECTION = { customers: 'desc', name: 'asc', curated: 'desc' }

export const paramsFromState = (state) => {
  const params = {}
  if (state.q.trim()) params.q = state.q.trim()
  if (state.type !== DEFAULT_STATE.type) params.type = state.type
  if (state.state !== DEFAULT_STATE.state) params.state = state.state
  if (state.iso !== DEFAULT_STATE.iso) params.iso = state.iso
  if (state.curated) params.curated = 'true'
  if (state.sort !== DEFAULT_STATE.sort) params.sort = state.sort
  if (state.direction !== DEFAULT_DIRECTION[state.sort]) params.direction = state.direction
  if (state.page !== DEFAULT_STATE.page) params.page = String(state.page)
  if (state.perPage !== DEFAULT_STATE.perPage) params.per_page = String(state.perPage)

  return params
}

export const stateFromQuery = (search) => {
  const query = new URLSearchParams(search)
  const sort = ['customers', 'name', 'curated'].includes(query.get('sort')) ? query.get('sort') : DEFAULT_STATE.sort
  const perPage = PER_PAGE_OPTIONS.includes(Number(query.get('per_page')))
    ? Number(query.get('per_page'))
    : DEFAULT_STATE.perPage

  return {
    q: query.get('q') || DEFAULT_STATE.q,
    type: query.get('type') || DEFAULT_STATE.type,
    state: query.get('state') || DEFAULT_STATE.state,
    iso: query.get('iso') || DEFAULT_STATE.iso,
    curated: query.get('curated') === 'true',
    sort,
    direction: ['asc', 'desc'].includes(query.get('direction')) ? query.get('direction') : DEFAULT_DIRECTION[sort],
    page: Math.max(Number(query.get('page')) || DEFAULT_STATE.page, 1),
    perPage
  }
}

// Returns up to 5 page numbers centered on the current page, clamped to [1, totalPages].
export const pageWindow = (current, totalPages) => {
  const span = 5
  if (totalPages <= span) return Array.from({ length: totalPages }, (_unused, index) => index + 1)

  let start = current - Math.floor(span / 2)
  start = Math.max(1, Math.min(start, totalPages - span + 1))

  return Array.from({ length: span }, (_unused, index) => start + index)
}
